<form [formGroup]="formGroup" class="db-advanced-settings mb20"
      *ngIf="!!dataLoaded"
  [ngClass]="{'disable-options': !!disableOptions || !!boosterUpdateAvailable}">
  <div class="db-advanced-settings__header mb35">
    <div>
      <h1>{{ 'text_advancedSettings' | dbText }}</h1>
      <p class="mt4" [innerHTML]="'text_tweakOptimizationSettings' | dbText: {companyName: companyName}"></p>
    </div>
    <div>
      <!--<a class="ds-btn rectangle mr20"
         (click)="resetAdvancedSettingsData()"
         [ngClass]="{'ds-btn-disabled': loading || loadingReset}">
        <span *ngIf="!loadingReset">RESET</span>
        <db-loading-circular-spinner *ngIf="loadingReset"></db-loading-circular-spinner>
      </a>-->
      <a class="ds-btn-green rectangle"
         (click)="saveAdvancedSettingsData()"
         [ngClass]="{'ds-btn-disabled': loading || disableBtn}">
        <span *ngIf="!loading">{{'text_saveTags' | dbText | lowerCaseSpecificWords}}</span>
        <db-loading-circular-spinner *ngIf="loading"></db-loading-circular-spinner>
      </a>
    </div>
  </div>
  <ng-container *ngFor="let formOptions of formGroupData; let i = index" >
    <div class="db-advanced-settings__lazy-load pt25 mt25 pb25" *ngIf="i === formGroupData.length - 1">
      <h1 class="dsd">{{ 'text_lazyload' | dbText }}</h1>
      <p class="mt4" [innerHTML]="'text_lazyLoadDesc' | dbText"></p>
    </div>
    <div class="db-advanced-settings__block mb20" [ngClass]="{'ds-lazy-load': !!lazyLoad}">
      <div *ngFor="let input of formOptions"
           [ngClass]="{
           'db-advanced-settings__with-border': ['two_delay_js_exclusions','two_aggregate_js','two_minify_js','two_aggregate_css','two_minify_css','two_include_inline_css','two_delay_js_exclusions','two_bg_lazyload','two_iframe_lazyload','two_video_lazyload'].includes(input?.name),
           'db-advanced-settings__sub-block': ['two_exclude_delay_js','two_delay_js_exclusions','two_exclude_js','two_minify_js','two_exclude_css','two_include_inline_css'].includes(input?.name),
           'mt30': ['two_exclude_delay_js','two_exclude_css', 'two_exclude_js'].includes(input?.name) || ('two_lazyload' === input?.name && (!!disableOptions || !!boosterUpdateAvailable)),
           'disabled-option': (
               (['two_delay_all_js_execution'].includes(input?.name) && ['on', true].includes(formGroup.get('two_aggregate_js').value) && !['on', true].includes(formGroup.get('two_delay_all_js_execution').value))
               || (['two_exclude_delay_js', 'two_delay_js_exclusions'].includes(input?.name) && !['on', true].includes(formGroup.get('two_delay_all_js_execution').value))
               || (['two_include_inline_css'].includes(input?.name) && !['on', true].includes(formGroup.get('two_aggregate_css').value))
               || (['two_aggregate_js', 'two_minify_js'].includes(input?.name) && ['on', true].includes(formGroup.get('two_delay_all_js_execution').value))
               || (['two_exclude_js', 'two_minify_js'].includes(input?.name) && (!['on', true].includes(formGroup.get('two_aggregate_js').value) || ['on', true].includes(formGroup.get('two_delay_all_js_execution').value)))
               )
           }">
        <div class="db-advanced-settings__tooltip {{input?.name}}">
          <p *ngIf="formTooltips[input?.name]" [innerHTML]="formTooltips[input?.name]"></p>
        </div>
        <div *ngIf="input?.field_type === 'checkbox'"
             class="db-advanced-settings__checkbox-block {{input?.value}} {{input?.value === 'on'}}"
             [ngClass]="{'ds-lazy-load': !dataLoaded}">
          <div>
            <p class="ds-checkbox-label mb4" [innerHTML]="input?.title"></p>
            <p class="ds-checkbox-description" [innerHTML]="input?.description"></p>
          </div>
          <div>
            <input class="ds-checkbox" type="checkbox" id="{{input?.name}}" [formControlName]="input?.name">
            <label class="ds-checkbox-description big green" for="{{input?.name}}"></label>
          </div>
        </div>
        <div class="db-advanced-settings__checkbox-block {{input?.name}}"
             *ngIf="input?.field_type === 'two_window_multiselect'"
             [ngClass]="{
               'ds-lazy-load': !dataLoaded,
               'mt30': input?.name === 'two_exclude_delay_js' || input?.name === 'two_exclude_css'
             }">
          <div class="multiselect-block">
            <p class="ds-checkbox-label mb4" [innerHTML]="input?.title"></p>
            <p class="ds-checkbox-description" [innerHTML]="input?.description"></p>
            <p class="ds-checkbox-sub-description mt30" *ngIf="input?.sub_description" [innerHTML]="input?.sub_description"></p>
            <ds-multiselect class="{{input?.sub_description ? 'mt8' : 'mt30'}}"
                            (dsChosenOptions)="choosedOptions($event?.options, input?.name === 'two_exclude_css' ? 'css' : 'js', input?.options)"
                            [dsDropdownOptions]="input?.options"
                            [dsDropDownTitle]="'text_managerPluginsThemes' | dbText"
                            [dsSelectedOptions]="isValidOption(input?.value, input?.options) ? input?.value : ('text_choose' | dbText)">
            </ds-multiselect>
          </div>
        </div>
        <div class="db-advanced-settings__select-block {{input?.name}}"
             *ngIf="input?.field_type === 'select'"
             [ngClass]="{
                'ds-lazy-load': !dataLoaded,
                'mt30': input?.name === 'two_exclude_delay_js' || input?.name === 'two_exclude_css'}">
          <div>
            <div>
              <p class="ds-checkbox-label mb4" [innerHTML]="input?.title"></p>
              <p class="ds-checkbox-description" [innerHTML]="input?.description"></p>
            </div>
            <div class="mt30">
              <p class="mb8" *ngIf="input?.name === 'two_delay_js_exclusions'">{{ 'text_selectPluginsToExclude' | dbText }}</p>
              <ds-dropdown
                [value]="formGroup.get(input?.name)?.value || ('text_choose' | dbText)"
                [dsDropdownLabel]="input?.label"
                [dsDropdownOptions]="input?.options"
                [dsDropdownPlaceHolder]="input?.placeholder || input?.label"
                [dsDropdownWithArrowIcon]="false"
                (onOptionChoose)="formGroup.get(input?.name).setValue($event)"
              ></ds-dropdown>
            </div>
          </div>
        </div>
        <div class="db-advanced-settings__checkbox-block {{input?.name}} {{formGroup.get('two_critical_status').value}} aaaaaaa"
             *ngIf="input?.field_type === 'textarea'"
             [ngClass]="{
                'ds-lazy-load': !dataLoaded,
                'mt30': input?.name === 'two_exclude_delay_js' || input?.name === 'two_exclude_css'
             }">
        <div class="ds-input-area">
            <div class="ds-textarea-label-wrap">
              <span class="ds-input-label" [innerHTML]="input?.title"></span>
              <span class="ds-input-label-desc">{{input?.description}}</span>
            </div>
            <div>
              <input type="text" class="ds-input ds-hide" [placeholder]="'text_addAnItem' | dbText"
                     [value]="(input?.name === 'two_exclude_css' ? excludeCss : (input?.name === 'two_exclude_delay_js' ? excludeFiles : excludeAggregationFiles)).toString()" [formControlName]="input?.name"/>
              <div class="db-advanced-settings__excluded-elements">
                <div *ngFor="let excludeItem of (input?.name === 'two_exclude_css' ? excludeCss : (input?.name === 'two_exclude_delay_js' ? excludeFiles : excludeAggregationFiles)); let i = index" [class]="'exclude_element-global exclude_element' + i" >
                  <div class="db-advanced-settings__excluded-el">{{ excludeItem | middleEllipsis: 40}}</div>
                  <i class="db-icon db-icon-ds-close-bg ml4" (click)="removeExcludedElement(excludeItem, input?.name)"></i>
                </div>
                <div [class]="'active exclude_element' + (input?.name === 'two_exclude_css' ? excludeCss : (input?.name === 'two_exclude_delay_js' ? excludeFiles : excludeAggregationFiles)).length + ' ' + input?.tab" [ngClass]="{'has-excludeItem': (input?.tab === 'css' ? excludeCss : excludeFiles)?.length}">
                  <input type="text" class="db-advanced-settings__exclude"
                         [value]=""
                         [placeholder]="
                         input?.name === 'two_exclude_css' ? (!excludeCss?.length ? ('text_exampleStylesCss' | dbText) : '')
                         : (((input?.name === 'two_exclude_delay_js' && !excludeFiles?.length) || (input?.name === 'two_exclude_js' && !excludeAggregationFiles?.length)) ? ('text_exampleJqueryMinJs' | dbText) : '')"
                         [formControl]="addedExcludedElementValue"
                         (keyup)="addExcludedValue($event, input?.name)"/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</form>
